"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PillTooltip;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _utils = require("@site/utils");
var _uxUtils = require("@site/ux-utils");
var _ToolTipWrapper = require("./ToolTipWrapper");
var _PillTooltip = require("./styles/PillTooltip");
function PillTooltip({
  tooltipLabel,
  tooltipTitle,
  tooltipBody
}) {
  const {
    isMobile
  } = (0, _uxUtils.useDeviceType)();
  const className = (0, _classnames.default)('d-inline-flex bd-a-1 bd-product px-2 extra-info ms-3', {
    'py-1': isMobile
  });
  return /*#__PURE__*/_react.default.createElement(_PillTooltip.PillTooltipContainer, null, /*#__PURE__*/_react.default.createElement("span", {
    className: className
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "text-muted ms-3"
  }, /*#__PURE__*/_react.default.createElement(_ToolTipWrapper.TooltipWrapper, {
    id: tooltipLabel,
    title: tooltipTitle,
    tooltipContent: /*#__PURE__*/_react.default.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: (0, _utils.sanitizeHTML)(tooltipBody)
      }
    }),
    tooltipLabelText: tooltipLabel,
    classNames: {
      tooltipWrapper: 'd-flex align-items-center lh-reset',
      tooltipButton: 'ml-2'
    },
    stopPropagation: true
  }))));
}
PillTooltip.propTypes = {
  tooltipLabel: _propTypes.default.string.isRequired,
  tooltipTitle: _propTypes.default.string.isRequired,
  tooltipBody: _propTypes.default.string.isRequired
};